import { FC } from 'react';
import { SubmissionErrorBoundary } from '../../components/errors/SubmissionErrorBoundary';
import { Modal } from '../../components/shared/modal/Modal';
import strings from './devices.translations';
import { EditDeviceForm } from './EditDeviceForm';

interface EditDeviceModalProps {
  open: boolean;
  name: string;
  locationId: number;
  onClose: () => void;
  id: string;
}

export const EditDeviceModal: FC<EditDeviceModalProps> = ({ open, onClose, locationId, id, name }) => {
  return (
    <Modal open={open} onClose={onClose} header={strings.editDeviceModal.title}>
      <SubmissionErrorBoundary>
        <EditDeviceForm id={id} name={name} locationId={locationId} onClose={onClose} />
      </SubmissionErrorBoundary>
    </Modal>
  );
};
